import Glide from '@glidejs/glide';
import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import {auto} from "@popperjs/core";
import $ from "jquery";
import 'jquery-countto';

/* PRELOADER */
const preloader = document.querySelector('.preloader')
const loadingBar = document.getElementById('loading-bar')

const startLoadingBarAnimation = () => {
    loadingBar.style.width = '0%'
    loadingBar.style.transition = 'width 1.5s ease'
    setTimeout(() => {
        loadingBar.style.width = '100%'
    }, 100)
    loadingBar.addEventListener('transitionend', () => {
        setTimeout(() => {
            preloader.classList.add('not-shown')
        }, 200)
    })
}

startLoadingBarAnimation()

/* PRELOADER */

/*modal featured que se muestre cuando pasen 5 segundos*/
const modalFeatured = document.getElementById('featuredModal');
if(modalFeatured){
    const modalFeaturedBootstrap = new bootstrap.Modal(modalFeatured);
    setTimeout(() => {
        modalFeaturedBootstrap.show();
    }, 5000);
}

// Slider principal en portada
let sliderPrincipal = new Glide('.section1__wrapper', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    autoplay: 8000,
    hoverpause: true,
    animationTimingFunc: 'ease-in-out',
    animationDuration: 900,
    breakpoints: {
        768: {
            perView: 1,
            autoplay: false,
            swipeThreshold: false,
            dragThreshold: false,
        }
    }
}).on('run.after', () => {
    const currentIndex = sliderPrincipal.index;

    // Eliminar la clase 'active' de todos los bullets
    const bullets = document.querySelectorAll('.bullet__btn');
    bullets.forEach(bullet => bullet.classList.remove('active'));

    // Agregar la clase 'active' al bullet correspondiente
    bullets[currentIndex].classList.add('active');
});

sliderPrincipal.mount();

// Calendario de la agenda (Full calendar)
document.addEventListener('DOMContentLoaded', function () {
    let calendarEl = document.getElementById('calendar');
    let calendar = new Calendar(calendarEl, {
        contentHeight: 'auto',
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        firstDay: 1,
        headerToolbar: {
            left: '', // Dejamos vacío, insertaremos el select manualmente
            right: 'prev,next',
        },
        //Tooltip de eventos
        eventDidMount: function (info) {
            tippy(info.el, {
                content: info.event.title, // El contenido es el título del evento
                theme: 'calendar__home', // Usar el tema personalizado
                placement: 'top', // Posicionar el tooltip arriba del evento
                arrow: true, // Mostrar una flecha en el tooltip
                delay: [300, 300],
            });
        },
        events: events,
        dayMaxEventRows: 1,
        datesSet: function () {
            createMonthSelect(calendar); // Llama a la función cada vez que se actualizan las fechas
        },
        moreLinkContent: function (args) {
            // Cambiar el texto "more" por "más" en español
            return '+' + args.num + ' más';
        },
        moreLinkClassNames: "color-primary"
    });
    calendar.setOption('locale', 'es');
    calendar.render();

    // Función para crear el select de meses y manejar el cambio de mes
    function createMonthSelect(calendar) {
        let currentMonth = calendar.getDate().getMonth();
        let currentYear = calendar.getDate().getFullYear(); // Obtener el año actual
        let select = document.createElement('select');
        // Arreglo de meses con el año actual
        let months = [
            {value: 0, name: 'Enero ' + currentYear},
            {value: 1, name: 'Febrero ' + currentYear},
            {value: 2, name: 'Marzo ' + currentYear},
            {value: 3, name: 'Abril ' + currentYear},
            {value: 4, name: 'Mayo ' + currentYear},
            {value: 5, name: 'Junio ' + currentYear},
            {value: 6, name: 'Julio ' + currentYear},
            {value: 7, name: 'Agosto ' + currentYear},
            {value: 8, name: 'Septiembre ' + currentYear},
            {value: 9, name: 'Octubre ' + currentYear},
            {value: 10, name: 'Noviembre ' + currentYear},
            {value: 11, name: 'Diciembre ' + currentYear}
        ];

        // Limpiar cualquier select existente antes de crear uno nuevo
        let toolbarLeft = document.querySelector('.fc-toolbar-chunk:nth-child(1)');
        toolbarLeft.innerHTML = ''; // Limpiamos la parte izquierda de la toolbar

        // Agregar las opciones al select
        months.forEach(function (month) {
            let option = document.createElement('option');
            option.value = month.value;
            option.textContent = month.name;
            if (month.value === currentMonth) {
                option.selected = true; // Selecciona el mes actual
            }
            select.appendChild(option);
        });

        // Cuando el usuario selecciona un nuevo mes
        select.addEventListener('change', function (e) {
            let selectedMonth = parseInt(e.target.value);
            let currentDate = calendar.getDate();
            calendar.gotoDate(new Date(currentDate.getFullYear(), selectedMonth, 1));
        });

        // Añadir el select en la toolbar izquierda
        toolbarLeft.appendChild(select);
    }
});

// Función para que la paginación de la agenda no recargue la página
function fetch_data(page) {
    axios({
        url: "?page=" + page, // Esto agrega el parámetro ?page=X en la URL
        method: 'get'
    }).then(function (response) {
        $('.section4__agenda-list').html(response.data); // Reemplaza el contenedor de la agenda con los datos nuevos
    }).catch(function () {
        alert('Hubo un problema al intentar cargar los datos.');
    });
}

// Delegar el evento clic en los links de la paginación
$(document).on('click', '.pagination a', function (event) {
    event.preventDefault(); // Evitar la recarga de página
    let page = $(this).attr('href').split('page=')[1]; // Obtener el número de página del link
    fetch_data(page); // Cargar la página seleccionada
});

//menu de la portada
const menuItems = document.querySelectorAll('.section6__menu-item');

menuItems.forEach(menuItem => {
    menuItem.addEventListener('click', function () {
        menuItems.forEach(i => i.classList.remove('active'));
        menuItem.classList.toggle('active');
        const menuSubitems = menuItem.querySelectorAll('.section6__submenu-item');
        menuSubitems.forEach(menuSubitem => {
            menuSubitem.addEventListener('click', function () {
                menuSubitems.forEach(i => i.classList.remove('active'));
                menuSubitem.classList.toggle('active');
            });
        });
    });
});
// Slider de los banners en página principal
const sliderBannersPrincipalesContainer = document.querySelector('.banners__principal__page');
if (sliderBannersPrincipalesContainer){
    const sliderBannersPrincipales = sliderBannersPrincipalesContainer.querySelectorAll('.glide__slide');
    if (sliderBannersPrincipales.length > 0){
        const sliderBannersPrincipalesConfig =  {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            hoverpause: true,
            animationTimingFunc: 'ease-in-out',
            animationDuration: 800,
        };

        if(sliderBannersPrincipales.length > 1){
            sliderBannersPrincipalesConfig.autoplay = 6000;
        }

        new Glide(sliderBannersPrincipalesContainer, sliderBannersPrincipalesConfig).mount();
    }
}

// Slider socios premium, plus y red
let sliderSociosPremium = new Glide('.socios__premium__slide', {
    type: 'carousel',
    startAt: 0,
    perView: 5,
    autoplay: 6000,
    hoverpause: true,
    animationTimingFunc: 'ease-in-out',
    animationDuration: 800,
    breakpoints: {
        992: {
            perView: 4
        },
        768: {
            perView: 2
        },
        576: {
            perView: 1
        }
    }
});
sliderSociosPremium.mount();

let sliderSociosPlus = new Glide('.socios__plus__slide', {
    type: 'carousel',
    startAt: 0,
    perView: 3,
    autoplay: 7000,
    hoverpause: true,
    animationTimingFunc: 'linear',
    animationDuration: 700,
    breakpoints: {
        992: {
            perView: 2
        },
        768: {
            perView: 1
        },
        576: {
            perView: 1
        }
    }
});
sliderSociosPlus.mount();

let sliderSociosRed = new Glide('.socios__red__slide', {
    type: 'carousel',
    startAt: 0,
    perView: 3,
    autoplay: 8000,
    hoverpause: true,
    animationTimingFunc: 'ease',
    animationDuration: 800,
    breakpoints: {
        992: {
            perView: 2
        },
        768: {
            perView: 1
        },
        576: {
            perView: 1
        }
    }
});
sliderSociosRed.mount();

//Para las animaciones de los números
$('.countto').countTo();
